module.exports = __webpack_public_path__ + "assets/img/feature-visual-2.dbbf0501.png";